(() => {
  const publish = (name, data = {}) => {
    try { window.DOPAAnalytics?.publish?.(name, data); } catch (_) {}
    try { window.dataLayer?.push?.({ event:name, ...data }); } catch (_) {}
  };

  const normalizeRest = (root = document) => {
    root.querySelectorAll?.('[data-cart-aov-rule]').forEach((node) => {
      node.textContent = String(node.textContent || '').replace(/NIGHT/g, 'REST');
    });
    root.querySelectorAll?.('[data-cart-aov-candidate="luna"] [data-aov-state]').forEach((node) => {
      node.textContent = 'REST';
    });
  };

  const stateList = ['focus','energy','hydrate','gut','build','lean','reset','rest','screen','fresh','drive','breathe'];
  const preferredStateKey = 'dopa_v58_state';
  const rememberState = (state) => {
    const clean = String(state || '').toLowerCase();
    if (!stateList.includes(clean)) return;
    try { localStorage.setItem(preferredStateKey, clean); } catch (_) {}
    document.querySelectorAll('[data-d57-state-select]').forEach((select) => {
      const option = [...select.options].find((item) => String(item.value || '').includes(`state-${clean}`));
      if (option) select.value = option.value;
    });
  };

  const restoreState = () => {
    let state = '';
    try { state = localStorage.getItem(preferredStateKey) || ''; } catch (_) {}
    if (state) rememberState(state);
  };

  document.querySelectorAll('[data-d57-finder]').forEach((finder) => {
    const steps = [...finder.querySelectorAll('[data-d57-step]')];
    const panel = finder.querySelector('[data-d57-result-panel]');
    const resetButton = finder.querySelector('[data-d57-finder-reset]');
    const backButton = finder.querySelector('[data-d57-finder-back]');
    const results = new Map([...finder.querySelectorAll('[data-d57-result]')].map((node) => [node.dataset.d57Result, node]));
    let scores = {};
    let stepOneScores = {};
    let started = false;

    const parseScores = (value) => {
      const output = {};
      String(value || '').split(',').forEach((entry) => {
        const [key, raw] = entry.split(':');
        const amount = Number(raw);
        if (key && Number.isFinite(amount)) output[key.trim()] = amount;
      });
      return output;
    };
    const merge = (base, extra) => {
      const next = { ...base };
      Object.entries(extra).forEach(([key, value]) => { next[key] = Number(next[key] || 0) + Number(value || 0); });
      return next;
    };
    const showStep = (number) => {
      steps.forEach((step) => {
        const active = Number(step.dataset.d57Step) === number;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      if (panel) panel.hidden = true;
      if (resetButton) resetButton.hidden = number === 1;
    };
    const winner = () => Object.entries(scores).sort((a, b) => b[1] - a[1])[0]?.[0] || 'focus';
    const showResult = () => {
      const state = winner();
      const data = results.get(state) || results.get('focus');
      steps.forEach((step) => { step.hidden = true; step.classList.remove('is-active'); });
      if (!panel || !data) return;
      panel.hidden = false;
      panel.querySelector('[data-d57-result-number]').textContent = data.dataset.number || '01';
      panel.querySelector('[data-d57-result-state]').textContent = state.toUpperCase();
      panel.querySelector('[data-d57-result-command]').textContent = data.dataset.command || '';
      panel.querySelector('[data-d57-result-copy]').textContent = data.dataset.copy || '';
      panel.querySelector('[data-d57-result-status]').textContent = data.dataset.status || '';
      const link = panel.querySelector('[data-d57-result-link]');
      link.href = data.dataset.href || '#';
      link.textContent = data.dataset.cta || `ENTER ${state.toUpperCase()}`;
      rememberState(state);
      if (resetButton) resetButton.hidden = false;
      publish('state_finder_completed', { state, surface:'home-v58' });
    };
    const reset = () => {
      scores = {};
      stepOneScores = {};
      started = false;
      showStep(1);
      publish('state_finder_reset', { surface:'home-v58' });
    };

    finder.addEventListener('click', (event) => {
      const answer = event.target.closest?.('[data-d57-answer]');
      if (!answer) return;
      const step = Number(answer.closest('[data-d57-step]')?.dataset.d57Step || 1);
      if (!started) {
        started = true;
        publish('state_finder_started', { surface:'home-v58' });
      }
      const selected = parseScores(answer.dataset.scores);
      if (step === 1) {
        scores = merge({}, selected);
        stepOneScores = { ...scores };
        publish('state_finder_step', { step:1, choice:String(answer.textContent || '').trim().slice(0,80), surface:'home-v58' });
        showStep(2);
      } else {
        scores = merge(scores, selected);
        publish('state_finder_step', { step:2, choice:String(answer.textContent || '').trim().slice(0,80), surface:'home-v58' });
        showResult();
      }
    });
    backButton?.addEventListener('click', () => {
      scores = { ...stepOneScores };
      showStep(1);
    });
    resetButton?.addEventListener('click', reset);
    showStep(1);
  });

  document.addEventListener('click', (event) => {
    const stateNode = event.target.closest?.('[data-d57-state]');
    if (stateNode) {
      const state = String(stateNode.dataset.d57State || '').toLowerCase();
      rememberState(state);
      publish('state_selected', { state, surface:'v58' });
    }
    const resultLink = event.target.closest?.('[data-d57-result-link]');
    if (resultLink) publish('state_finder_result_clicked', { state:String(resultLink.closest('[data-d57-result-panel]')?.querySelector('[data-d57-result-state]')?.textContent || '').toLowerCase(), surface:'home-v58' });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form?.classList?.contains('d57-access-form')) {
      const select = form.querySelector('[data-d57-state-select]');
      const value = String(select?.value || '');
      const match = value.match(/state-([a-z0-9-]+)/i);
      publish('state_interest', { state:match?.[1] || '', surface:'home-v58' });
    }
    if (form?.classList?.contains('d57-pdp-form')) {
      const section = form.closest('[data-d57-core-product]');
      const state = section?.dataset.state || '';
      const preorder = Boolean(form.querySelector('[name="properties[Pre-order delivery]"]'));
      publish(preorder ? 'preorder_add_attempted' : 'add_to_cart_attempted', { state, surface:'pdp-v58' });
    }
  }, true);

  const bindV58MobileBuy = () => {
    const bar = document.querySelector('[data-mobile-buy]');
    const form = document.querySelector('.d57-pdp-form');
    if (!bar || !form || bar.dataset.d58Bound === 'true') return;
    bar.dataset.d58Bound = 'true';
    const submit = form.querySelector('[data-product-submit]');
    const button = bar.querySelector('[data-mobile-add]');
    const media = window.matchMedia('(max-width: 800px)');
    let ticking = false;

    button?.addEventListener('click', () => {
      if (!submit || submit.disabled) {
        form.scrollIntoView({ behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center' });
        return;
      }
      if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
    });

    const sync = () => {
      ticking = false;
      if (!media.matches || !submit) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden','true');
        return;
      }
      const submitRect = submit.getBoundingClientRect();
      const formRect = form.getBoundingClientRect();
      const submitVisible = submitRect.bottom > 0 && submitRect.top < window.innerHeight;
      const reached = formRect.top < window.innerHeight * .4;
      const blocked = document.body.classList.contains('cart-drawer-open') || document.body.classList.contains('menu-open');
      const show = reached && !submitVisible && !blocked;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    const queue = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    };
    window.addEventListener('scroll', queue, { passive:true });
    window.addEventListener('resize', queue, { passive:true });
    document.addEventListener('dopa:cart-added', queue);
    queue();
  };

  document.addEventListener('dopa:cart-rendered', () => normalizeRest(document));
  document.addEventListener('dopa:cart-updated', () => normalizeRest(document));
  document.addEventListener('DOMContentLoaded', () => {
    normalizeRest(document);
    restoreState();
    bindV58MobileBuy();
    const pdp = document.querySelector('[data-d57-core-product]');
    if (pdp) publish('product_view', { state:pdp.dataset.state || '', surface:'pdp-v58' });
  });
})();
